/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { ClientDto } from '../models/ClientDto';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param version 
     * @param id 
     * @returns ClientDto Success
     * @throws ApiError
     */
    public getVClientsId(
version: string,
id?: number,
): Observable<ClientDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/Clients/id',
            path: {
                'version': version,
            },
            query: {
                'id': id,
            },
        });
    }

    /**
     * @param version 
     * @returns ClientDto Success
     * @throws ApiError
     */
    public getVClients(
version: string,
): Observable<Array<ClientDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/Clients',
            path: {
                'version': version,
            },
        });
    }

}
